import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  any,
  complement,
  map,
  split,
  flatten,
  pipe,
  concat,
  unless,
  startsWith,
  filter,
  defaultTo
} from 'ramda'
import withFieldError from 'components/form/with-error'

export const MatchHandle = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter handle e.g. @handle',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

MatchHandle.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const MatchHandleWithError = withFieldError(MatchHandle)

const noValue = either(isNil, isEmpty)
const hasInvalidHandles = any(complement(window.twttr.txt.isValidUsername))

export const validate = cond([
  [either(noValue, hasInvalidHandles), always('Please enter valid handles')]
])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty)),
  map(unless(startsWith('@'), concat('@')))
)

const MatchHandleField = ({ name }) => (
  <div>
    <Field
      name={`${name}.handles`}
      component={MatchHandleWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

MatchHandleField.propTypes = {
  name: PropTypes.string
}

export default MatchHandleField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/match-handle/index.js